import { useEffect } from 'react';
import PropTypes from 'prop-types';


function Smi2({ id, height }) {
  useEffect(() => {
    if (!process.env.BROWSER_RUNTIME) return;
    (function() {
      const sc = document.createElement('script'); sc.type = 'text/javascript'; sc.async = true;
      sc.src = `//smi2.ru/data/js/${id}.js`; sc.charset = 'utf-8';
      const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sc, s);
    }());
  }, [id]);

  return <div id={`unit_${id}`} style={{ minHeight: height }} ><a href='https://smi2.ru/' >Новости СМИ2</a></div>;
}

Smi2.propTypes = {
  id: PropTypes.number.isRequired,
  height: PropTypes.number,
};

export default Smi2;
